import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneEnter: any = null,
    sceneLeave: any = null,
    sceneTextEnterN: any = null,
    sceneTextLeaveN: any = null;
export default function N() {
    const { useLang, useRouter, useEffect, useState, gtm, Link, useRef } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const videoRef = useRef();
    const [textEnter, setTextEnter] = useState(false);
    const [showIcon, setShowIcon] = useState(false);

    const handleReplay = () => {
        setShowIcon(false);
        videoRef.current.currentTime = 0;
        videoRef.current.play();
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            video_name: t('secF_title'),
            position: 'Product Launch_8',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                const video = document.querySelector('.dpu-detail-N .video') as HTMLVideoElement;
                if (video) {
                    if (sceneEnter) AniContainer.removeScene(sceneEnter);
                    if (sceneLeave) AniContainer.removeScene(sceneLeave);

                    sceneEnter = AniContainer.create({
                        triggerElement: '.dpu-detail-N .video',
                        triggerHook: 1,
                        offset: video?.offsetHeight / 2,
                        duration: window?.innerHeight - video?.offsetHeight / 2,
                        onEnter: () => {
                            setShowIcon(false);
                            videoRef.current.play();
                        },
                    });

                    sceneLeave = AniContainer.create({
                        triggerElement: '.dpu-detail-N .video',
                        triggerHook: 1,
                        offset: 0,
                        duration: window?.innerHeight + video?.offsetHeight,
                        onLeave: () => {
                            videoRef.current.pause();
                            videoRef.current.currentTime = 0;
                        },
                    });
                }
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnter) AniContainer.removeScene(sceneEnter);
                if (sceneLeave) AniContainer.removeScene(sceneLeave);
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterN) {
                    AniContainer.removeScene(sceneTextEnterN);
                    sceneTextEnterN = null;
                }
                if (sceneTextLeaveN) {
                    AniContainer.removeScene(sceneTextLeaveN);
                    sceneTextLeaveN = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterN = AniContainer.create({
                    triggerElement: '.dpu-detail-N .text-info',
                    triggerHook: 1,
                    offset: startH, //isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    duration: 200, // window.innerHeight - isOnlyH5 ? textTarget?.offsetHeight / 2 : textTarget?.offsetHeight,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveN = AniContainer.create({
                //     triggerElement: '.dpu-detail-N .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 2,
                //     onLeave: () => setTextEnter(false),
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterN) {
                    AniContainer.removeScene(sceneTextEnterN);
                    sceneTextEnterN = null;
                }
                if (sceneTextLeaveN) {
                    AniContainer.removeScene(sceneTextLeaveN);
                    sceneTextLeaveN = null;
                }

                //window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-N dpu-detail-section ${css['dpu-detail-N']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h4 className="subtitle">{t('secN_subtitle')}</h4>
                <h2 className="title">{t('secN_title')}</h2>
                <p className="desc">{t('secN_desc')}</p>
                {!['br'].includes(locale) && (
                    <Link className="link" href={'/smart-home-panel-2'} target="_blank">
                        <span className="link-text">{t('secN_link')}</span>
                        <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M6.25651 2.35889L11.5898 7.69222L6.25651 13.0256"
                                stroke="#3F68E0"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </Link>
                )}
            </div>
            <div className="video-box">
                <video
                    className="video fullImgs"
                    ref={videoRef}
                    src={'/responsive/video/delta-pro-ultra/launch/14.mp4'}
                    autoPlay
                    // loop
                    muted
                    playsInline
                    preload="auto"
                    width="100%"
                    height="100%"
                    poster="/responsive/picture/delta-pro-ultra/launch/14.jpg"
                    aria-label={t('secN_title')}
                    onEnded={() => setShowIcon(true)}
                />
                {showIcon && (
                    <svg
                        className="replay-icon"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={handleReplay}
                    >
                        <rect width="29.9995" height="29.9995" rx="14.9998" fill="#707070" />
                        <path
                            d="M9.54492 8.18164L13.6358 8.18164L13.6358 12.2725"
                            stroke="white"
                            strokeWidth="1.36361"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.0445 9.89298C18.2993 10.3351 19.3764 11.173 20.1135 12.2804C20.8507 13.3879 21.208 14.705 21.1315 16.0331C21.0551 17.3613 20.5491 18.6287 19.6897 19.6443C18.8304 20.6599 17.6642 21.3687 16.367 21.6639C15.0698 21.9591 13.7118 21.8247 12.4976 21.2809C11.2834 20.7372 10.2788 19.8136 9.63511 18.6493C8.99146 17.485 8.74364 16.143 8.92899 14.8256C9.11435 13.5082 9.72283 12.2867 10.6628 11.3452L13.6354 8.18164"
                            stroke="white"
                            strokeWidth="1.36361"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </div>
        </section>
    );
}
